import {
   ButtonFragment,
   TradeInLayout,
   TradeInLayoutH1,
   TradeInLayoutMainPanel,
   TradeInLayoutWidgets
} from "../../Queries";

export type NoUndefinedField<T> = { [P in keyof T]-?: NoUndefinedField<Omit<NonNullable<T[P]>, '__typename' | '_id'>> };

export const h1Layout: TradeInLayoutH1 = {
   fontSize: "24px",
   fontWeight: "bold"
};

export const h2Layout: TradeInLayoutH1 = {
   fontSize: "20px",
   fontWeight: "bold",
};

export const textLayout: TradeInLayoutH1 = {
   fontSize: "16px",
};
export const subTextLayout: TradeInLayoutH1 = {
   fontSize: "14px",
};

export const mainPanelLayout: TradeInLayoutMainPanel = {
   textColor: "#000000",
   backgroundColor: "#ffffff",
   mainButton: {
      buttonColor: "#000000",
      textColor: "#ffffff",
   },
   secondaryButton: {
      buttonColor: "#e0e0e0",
      textColor: "#ffffff",
   },
};

export const contrastPanelLayout: TradeInLayoutMainPanel = {
   textColor: "#ffffff",
   backgroundColor: "#063B91",
   mainButton: {
      buttonColor: "#000000",
      textColor: "#ffffff",
   },
   secondaryButton: {
      buttonColor: "#e0e0e0",
      textColor: "#ffffff",
   }
};

export const addItemDefaults: ButtonFragment = {

}

export const widgetsLayout:TradeInLayoutWidgets = {
   addItemButton: addItemDefaults
};

export const defaultLayout: TradeInLayout = {
   fontFamily: 'Arial',
   h1: h1Layout,
   h2: h2Layout,
   text: textLayout,
   subtext: subTextLayout,
   mainPanel: mainPanelLayout,
   contrastPanel: contrastPanelLayout,
   frontPanel: mainPanelLayout,
   widgets: widgetsLayout
}

